import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({ standalone: false,
  selector: 'app-list-skeleton',
  templateUrl: './list-skeleton.component.html',

  styleUrls: []
})
export class ListSkeletonComponent {

}
